/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Search from "./components/Search";
import Table from "./components/Table";
import { mailBoxPAM } from "../../Api";
import { setTitlePage, isValidDate, isOnlyNumbers } from "../../Functions";
import PaginationComponent from "../../components/PaginationComponent/PaginationComponent";
import Modal from "../../components/Modal/Modal";
import { Modal as ModalBootstrap } from 'bootstrap';
import ActualPam from "./components/ActualPam";
import { AlertDialog } from "../../components/Dialog/Dialog";

const MailBoxPam = () => {

    const [state, setState] = useState<any>({
        data: [],
        pages: 0,
        pageIndex: 0,
        pageSize: 10,
        loading: false,
    });

    const [filters, setFilters] = useState<any>({})
    const [modalData, setModalData] = useState<any>({})
    const [showAlertError, setShowAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('No se encontraron resultados para tu búsqueda.');

    const handleError = (e: any) => {
        console.log(e)
        setState({ ...state, loading: false })
    }


    useEffect(() => {
        setTitlePage('Buzón PAM')
    }, [])

    const _handleGetData = async (pageIndex: any = 0, pageSize: any = 10, fnFilters: any = null) => {
        setState({ ...state, loading: true })
        try {
            let data: any = { ...filters };
            data.paginate = pageIndex;
            data.numberrecords = pageSize;

            if (fnFilters) {
                data = { ...data, ...fnFilters };
                data.paginate = 1;
                setFilters({ ...fnFilters })
            }

            if(data.shipping_start_date.length > 0 && !isValidDate(data.shipping_start_date)) {
              setMessageAlertError('El formato de Fecha Desde, es incorrecto!');
              setShowAlertError(true);
              handleError('');
              return;
            }
            if(data.shipping_end_date.length > 0 && !isValidDate(data.shipping_end_date)) {
              setMessageAlertError('El formato de Fecha hasta, es incorrecto!');
              setShowAlertError(true);
              handleError('');
              return;
            }
            if(data.rol.length > 0 && (!isOnlyNumbers(data.rol) || data.rol.length > 15)){
              setMessageAlertError('El formato del Rol, es incorrecto!');
              setShowAlertError(true);
              handleError('');
              return;
            }
            if(data.solicitud.length > 0 && (!isOnlyNumbers(data.solicitud) || data.solicitud.length > 15)){
              setMessageAlertError('El formato de N° Solicitud, es incorrecto!');
              setShowAlertError(true);
              handleError('');
              return;
            }

            const response: any = await mailBoxPAM(data);
            const { totalrecords, paginate, totalpaginate } = response.data.pagination;
            setState({
                ...state,
                data: response.data.records,
                pageCount: parseInt(totalrecords),
                pageIndex: parseInt(paginate),
                pageSize: pageSize,
                pages: parseInt(totalpaginate),
                loading: false
            })
        } catch (e: any) {
            handleError(e)
        }
    }

    const _handleModalPam = (payload: any) => {
        setModalData(payload)
        const modal: any = new ModalBootstrap('#actual_pam');
        modal.show();
    }

    const _handleError = (e: any) => {
        console.log(e)
    }

    return (
        <div>
            <Modal id="actual_pam" size="modal-xl" title="Ver PAM" >
                <ActualPam {...modalData} handleError={_handleError} />
            </Modal>
            <Search _handleSearch={(values: any) => _handleGetData(state.pageIndex, state.pageSize, values)} _handleError={handleError} loading={state.loading} />
            <div className="card card-xl-stretch mb-xl-8 mt-5">

                <Table data={state.data} loading={state.loading} _handleModalPam={_handleModalPam} />

                <div className="my-5">
                    <PaginationComponent totalPages={state.pages} activePage={state.pageIndex} searchData={_handleGetData} loading={state.loading} />
                </div>
            </div>
            <AlertDialog
                message={messageAlertError}
                show={showAlertError}
                success={false}
                onConfirm={() => {
                    setShowAlertError(false);
                }}
            />
        </div>
    );
}

export default MailBoxPam;